import { render } from "./ArrowIcon.vue?vue&type=template&id=7dd31777"
import script from "./ArrowIcon.vue?vue&type=script&lang=js"
export * from "./ArrowIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__